<template>
  <div id="main-content" class="day-off-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="dayOffInfo">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.title') }}:</span>
            <span class="info-span"> {{ dayOffInfo.title }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.type') }}:</span>
            <span class="info-span"> {{ getType(dayOffInfo.type) }} </span>
          </el-col>
        </el-row>
        <template v-if="dayOffInfo.type === DAY_OFF_TYPE_DATE">
          <el-row>
            <el-col :span="24">
              <span class="form-lable">{{ $t('common.date') }}:</span>
              <span class="info-span"> {{ dayOffInfo.data.date }} </span>
            </el-col>
          </el-row>
        </template>

        <template v-if="dayOffInfo.type === DAY_OFF_TYPE_DAY">
          <el-row>
            <el-col :span="24">
              <span class="form-lable">{{ $t('common.day') }}:</span>
              <span class="info-span"> {{ getDay(dayOffInfo.data.day) }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="form-lable">{{ $t('common.start_date') }}:</span>
              <span class="info-span"> {{ dayOffInfo.data.start_date }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="form-lable">{{ $t('common.end_date') }}:</span>
              <span class="info-span"> {{ dayOffInfo.data.end_date }} </span>
            </el-col>
          </el-row>
        </template>

        <template v-if="dayOffInfo.type === DAY_OFF_TYPE_PERIOD">
          <el-row>
            <el-col :span="24">
              <span class="form-lable">{{ $t('common.start_date') }}:</span>
              <span class="info-span"> {{ dayOffInfo.data.start_date }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="form-lable">{{ $t('common.end_date') }}:</span>
              <span class="info-span"> {{ dayOffInfo.data.end_date }} </span>
            </el-col>
          </el-row>
        </template>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import {
    DAY_OFF_TYPE_DATE,
    DAY_OFF_TYPE_DAY,
    DAY_OFF_TYPE_PERIOD,
    DAY_LIST_FULL
  } from '@/config'

  export default {
    name: "DayOffDetail",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'day_off.day_off_information',
        backLink: `/general/day-off?action=back`,
        DAY_OFF_TYPE_DATE,
        DAY_OFF_TYPE_DAY,
        DAY_OFF_TYPE_PERIOD,
        dayOffInfo: null
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.dayOffInfo = Object.assign({}, response.data.data.day_off_info)
      }
      let payload = {
        successCallback,
        id: this.$route.query.id
      }
      this.$store.dispatch('dayOff/retrieveDayOffDetail', payload)
    },
    computed: {

    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/general/day-off/edit', query: {id: this.$route.query.id}});
      },
      getType (type) {
        switch (type) {
          case DAY_OFF_TYPE_DATE:
            return this.$t('common.date')
          case DAY_OFF_TYPE_DAY:
            return this.$t('common.day')
          default:
            return this.$t('common.period')
        }
      },
      getDay (day) {
        return typeof DAY_LIST_FULL[day] !== 'undefined' ? DAY_LIST_FULL[day] : ''
      }
    }
  }
</script>

<style lang="scss">
</style>